/* MASONTEX · Media Core — preload.js (flat asset path)
   Predictive image warming. Offscreen Image() only — no DOM layout.
   DOM dataset contract (msPrefetched) stays in oem-product-lite.js. */
(function (global) {
  'use strict';

  const api = (global.MasontexMediaCore = global.MasontexMediaCore || {});
  const preload = {};

  preload.createWarmCache = () => {
    const warmed = new Set();
    return {
      has: (url) => warmed.has(url),
      warm(url) {
        if (!url || warmed.has(url)) return;
        warmed.add(url);
        if (typeof Image !== 'undefined') {
          const image = new Image();
          image.decoding = 'async';
          image.src = url;
        }
      },
      warmPayload(payload, seen) {
        if (!payload) return;
        if (payload.base && !seen.has(payload.base)) {
          seen.add(payload.base);
          this.warm(payload.base);
        }
        if (payload.overlay && !seen.has(payload.overlay)) {
          seen.add(payload.overlay);
          this.warm(payload.overlay);
        }
      },
      size: () => warmed.size
    };
  };

  preload.prefetch = (ctx, warmCache, payloadFn) => {
    const n = api.normalize;
    const r = api.resolver;
    const seen = new Set();
    const structureKey = ctx.state.structure;
    const viewKey = ctx.state.view;
    ctx.lists.colors.forEach((color) => warmCache.warmPayload(payloadFn(n.itemKey(color), ctx.state.visor, structureKey, viewKey), seen));
    ctx.lists.visors.forEach((visor) => warmCache.warmPayload(payloadFn(ctx.state.color, n.itemKey(visor), structureKey, viewKey), seen));
    ctx.lists.views.forEach((view) => {
      if (!ctx.hasFullConfig) {
        warmCache.warm(r.fallbackViewImage(ctx, n.itemKey(view)));
        return;
      }
      warmCache.warmPayload(payloadFn(ctx.state.color, ctx.state.visor, structureKey, n.itemKey(view)), seen);
    });
  };

  preload.schedule = (run) => {
    if (typeof requestIdleCallback === 'function') requestIdleCallback(run, { timeout: 800 });
    else setTimeout(run, 500);
  };

  /* State-aware prewarm scheduler: debounces repeated state changes and runs
     the warm once on idle. Reuses the same warm logic — no new URL coverage. */
  preload.createDebounced = (fn, delay = 500) => {
    let timer = null;
    let idleTimer = null;
    const run = () => {
      idleTimer = null;
      fn();
    };
    return {
      schedule() {
        if (timer) clearTimeout(timer);
        timer = setTimeout(() => {
          timer = null;
          if (typeof requestIdleCallback === 'function') {
            idleTimer = requestIdleCallback(run, { timeout: 800 });
          } else {
            run();
          }
        }, delay);
      },
      cancel() {
        if (timer) clearTimeout(timer);
        if (idleTimer && typeof cancelIdleCallback === 'function') cancelIdleCallback(idleTimer);
        timer = null;
        idleTimer = null;
      }
    };
  };

  api.preload = preload;
})(typeof window !== 'undefined' ? window : globalThis);
